import DNTile from './modules/DNTile';
import DNTab from './modules/DnTab';
import DnPageAnchor from './modules/DnPageAnchor';



export default class OldModuleManager {
  constructor() {
    new DNTile().init();
    new DNTab().init();
    new DnPageAnchor().init();
  }
}


// WEBPACK FOOTER //
// ./src/js/manager/old-modules/OldModuleManager.js